export function mergeStageOptionsWithStale(liveStages, savedNames = []) {
  const live = [];
  const seen = new Set();
  for (const name of liveStages || []) {
    const trimmed = String(name || "").trim();
    if (!trimmed || seen.has(trimmed)) continue;
    seen.add(trimmed);
    live.push(trimmed);
  }
  const stale = [];
  for (const name of savedNames || []) {
    const trimmed = String(name || "").trim();
    if (!trimmed || seen.has(trimmed)) continue;
    seen.add(trimmed);
    stale.push(trimmed);
  }
  return { live, stale, all: [...live, ...stale] };
}

export function initialEligibleSelection(currentEligible) {
  if (!Array.isArray(currentEligible) || currentEligible.length === 0) {
    return [];
  }
  return currentEligible.map((name) => String(name || "").trim()).filter(Boolean);
}
